export default function Link(theme) {
  const isDark = theme.palette.mode === 'dark';

  return {
    MuiLink: {
      styleOverrides: {
        root: {
          // MUI's Link defaults to primary.main, which is the same medium blue in
          // both modes. On the dark background that blue has poor contrast, so
          // switch to a lighter primary shade when dark mode is active.
          color: isDark ? theme.palette.primary.lighter : theme.palette.primary.main
        }
      }
    }
  };
}
